import React, { useState } from "react";
import Modal from "react-bootstrap/Modal";
import { pushNotification } from "utils/notifications";
import { formatNumber } from "utils/currencyFormat";
import { getDate } from "utils/formatDate";
import KhoiPhucPhieuBiXoaApi from "service/khoiPhucPhieuBiXoaApi";
import { LOAI_PHIEU_KHOI_PHUC } from "./loaiPhieu";

const GHI_NHAN_LAI_QUY = "Phiếu được ghi nhận lại vào quỹ.";

const MO_TA_KHOI_PHUC = {
  0: GHI_NHAN_LAI_QUY,
  10: GHI_NHAN_LAI_QUY,
  19: GHI_NHAN_LAI_QUY,
  20: GHI_NHAN_LAI_QUY,
  54: "Phiếu được ghi nhận lại vào quỹ và cộng lại vào số tiền đã thu của đơn bán hàng.",
  1: "Phiếu được ghi nhận lại vào quỹ và phân bổ lại vào các kỳ lãi của hợp đồng.",
  3: "Phiếu được ghi nhận lại vào quỹ và phân bổ lại vào các kỳ của hợp đồng nhận vay.",
  4: "Hợp đồng nhận vay được khôi phục cùng các phiếu bị hủy khi xóa hợp đồng (trả lãi kỳ đầu, trả bớt gốc, vay thêm), quỹ được ghi nhận lại và tài sản thế chấp được gắn lại; file đính kèm của hợp đồng không khôi phục được.",
  13: "Hợp đồng nhận vay được tất toán lại theo đúng ngày, số tiền của phiếu và đóng lại.",
  16: "Phiếu được ghi nhận lại vào quỹ và vào tiền khách trả của hồ sơ thanh lý; tài sản chuyển lại đã thanh lý.",
  18: "Gốc của hợp đồng nhận vay giảm lại theo phiếu và lịch kỳ được rải lại như khi nhập trả bớt gốc.",
  71: "Gốc của hợp đồng nhận vay tăng lại theo phiếu và lịch kỳ được rải lại như khi nhập vay thêm.",
  25: "Phiếu được ghi nhận lại vào quỹ và phân bổ lại vào các kỳ lãi, phần dư thành kỳ quá hạn như lúc đóng.",
  11: "Hợp đồng được tất toán lại theo đúng ngày, số tiền của phiếu và đóng lại; tài sản cầm cố chuyển về đã trả.",
  17: "Phiếu được ghi nhận lại vào quỹ, gốc của hợp đồng giảm lại và lịch kỳ lãi được rải lại.",
  21: "Phiếu được ghi nhận lại vào quỹ, gốc của hợp đồng tăng lại và lịch kỳ lãi được rải lại.",
};

export const KhoiPhucPhieu = ({ show, onHide, item, onDaKhoiPhuc }) => {
  const [dangXuLy, setDangXuLy] = useState(false);

  const khoiPhuc = () => {
    if (dangXuLy) return;
    setDangXuLy(true);
    const baoLoi = (message) => {
      setDangXuLy(false);
      pushNotification(message || "Khôi phục không thành công", "error", "TOP_CENTER", 3000);
    };
    KhoiPhucPhieuBiXoaApi.khoiPhuc(item.ThuChiID)
      .then((response) => {
        const { Error, Message } = response.data || {};
        if (Error !== 0) return baoLoi(Message);
        // onHide gỡ modal khỏi cây nên không set state sau đó
        onHide();
        if (onDaKhoiPhuc) onDaKhoiPhuc();
        pushNotification(Message, "success", "TOP_CENTER", 1500);
      })
      .catch(() => baoLoi());
  };

  return (
    <Modal
      show={show}
      onHide={onHide}
      size="modal-dialog modal-dialog"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      className="modal-new modal fade text-left"
    >
      <Modal.Header>
        <h4 className="modal-title">
          <span className="btn-icon-right">
            <i className="mdi mdi-restore"></i>
          </span>
          Xác nhận khôi phục
        </h4>
        <button type="button" className="close-popup-new" onClick={onHide}>
          <i className="mdi mdi-close"></i>
        </button>
      </Modal.Header>
      <Modal.Body>
        <form className="form tat-toan form-horizontal">
          <div className="form-body">
            <div className="form-group row">
              <label className="col-md-12 label-control text-left">
                Bạn có chắc chắn muốn khôi phục phiếu{" "}
                {LOAI_PHIEU_KHOI_PHUC[item.Type]} số tiền{" "}
                {formatNumber(Math.abs(item.Value))}
                {item.ChoVayId
                  ? ` của hợp đồng ${item.Code}`
                  : item.NhanVayId
                  ? ` của hợp đồng nhận vay ${item.Code}`
                  : ` ngày ${getDate(item.Time)}`}{" "}
                không? {MO_TA_KHOI_PHUC[item.Type]}
              </label>
            </div>
          </div>
        </form>
      </Modal.Body>
      <Modal.Footer>
        <button
          type="button"
          className="btn btn-new-main btn-checknew"
          onClick={khoiPhuc}
          disabled={dangXuLy}
        >
          <span className="btn-icon-left">
            <i className="mdi mdi-check"></i>
          </span>
          {dangXuLy ? "Đang xử lý..." : "Xác nhận"}
        </button>
        <button
          type="button"
          className="btn btn-new-main btn-closenew"
          onClick={onHide}
        >
          <span className="btn-icon-left">
            <i className="mdi mdi-close"></i>
          </span>
          Đóng
        </button>
      </Modal.Footer>
    </Modal>
  );
};
